export default class ModalFormRepreController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('~/scripts/services/model/form').default} form
	 * @param {any} submission
	 */
	constructor($injector, $scope, $uibModalInstance, form, submission) {
		this.$uibModalInstance = $uibModalInstance;
		this.form = form;
		this.submission = submission;
		this.tmp = null;

		$scope.$watch('$ctrl.form.formio.kformForm.$dirty', dirty => {
			this.form.modified = dirty;
		});
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}

	submit() {
		this.$uibModalInstance.close({ submission: this.submission });
	}
}
